export const reducer = (state, action) => {
  switch (action.type) {

    case 'REPLACE_STATE':
      return action.payload;

    case 'UPDATE_PROPERTY':
      if (Array.isArray(state[action.payload.property]) && action.payload.index !== undefined) {
        return {
          ...state,
          [action.payload.property]: state[action.payload.property].map((item, index) =>
            index === action.payload.index ? action.payload.value : item
          ),
        };
      } else {
        return {
          ...state,
          [action.payload.property]: action.payload.value,
        };
      }

    case 'ADD_AXLE_GROUP':
      return {
        ...state,
        axleGroups: [
          ...state.axleGroups,
          action.payload.value
        ],
      };

    case 'REMOVE_AXLE_GROUP':
      return {
        ...state,
        axleGroups: state.axleGroups.filter(axleGroup => axleGroup.id !== action.payload.axleGroupId),
      };

    case 'UPDATE_AXLE_GROUP':
      return {
        ...state,
        axleGroups: state.axleGroups.map(axleGroup =>
          axleGroup.id === action.payload.axleGroupId
            ? { ...axleGroup, [action.payload.property]: action.payload.value }
            : axleGroup
        ),
      };

    case 'UPDATE_MULTIPLE_AXLE_GROUP_PROPERTIES':
      return {
        ...state,
        axleGroups: state.axleGroups.map(axleGroup =>
          axleGroup.id === action.payload.axleGroupId
            ? {
              ...axleGroup,
              ...action.payload.properties.reduce((acc, prop) => ({ ...acc, [prop.propertyName]: prop.value }), {})
            }
            : axleGroup
        ),
      };
    case 'REPLACE_AXLE_GROUP':
      return {
        ...state,
        axleGroups: state.axleGroups.map(axleGroup =>
          axleGroup.id === action.payload.value.id
            ? action.payload.value
            : axleGroup
        ),
      };

    case 'UPDATE_AXLE':
      return {
        ...state,
        axleGroups: state.axleGroups.map(axleGroup => {
          if (axleGroup.id === action.payload.axleGroupId) {
            return {
              ...axleGroup,
              axles: axleGroup?.axles?.map(axle => {
                if (axle.id === action.payload.axleId) {
                  return { ...axle, [action.payload.property]: action.payload.value }
                }
                return axle;
              })
            };
          }
          return axleGroup;
        }),
      };

    case 'UPDATE_MULTIPLE_AXLE_PROPERTIES':
      return {
        ...state,
        axleGroups: state.axleGroups.map(axleGroup => {
          if (axleGroup.id === action.payload.axleGroupId) {
            return {
              ...axleGroup,
              axles: axleGroup?.axles?.map(axle => {
                if (axle.id === action.payload.axleId) {
                  return {
                    ...axle,
                    ...action.payload.properties.reduce((acc, prop) => ({ ...acc, [prop.propertyName]: prop.value }), {})
                  }
                }
                return axle;
              })
            };
          }
          return axleGroup;
        }),
      };

    default:
      alert(`Unknown action type: ${action.type}`);
      return state;
  }
};


